import { createContext, useContext } from 'react';

export interface ChatColors {
  primary: string;
}

export const DEFAULT_COLORS: ChatColors = { primary: '#E91E8C' };

export const ChatColorsContext = createContext<ChatColors>(DEFAULT_COLORS);

export function useChatColors(): ChatColors {
  return useContext(ChatColorsContext);
}
